<template>
  <mobialisCard>
    <div class="row">
      <div class="flex-column pl-3">
        <div class="credit-card-success-icon-wrapper img">
          <inline-svg class="credit-card-success-icon" :src="require('@/assets/ic-credit-check.svg')" />
        </div>
      </div>
      <div class="col">
        <h2 data-cy="heading" class="my-2 heading">
          {{ $t('message.credit.applyNowTitle') }}
        </h2>
        <p class="mb-4 mt-2" data-cy="bodyCopy">{{ $t('message.credit.nextText') }}</p>
        <MobialisButton
          data-cy="applyNow"
          @click="btnClick"
          width="w-auto"
          v-av-analytics-cta-interaction="{ elementText: $t('message.common.applyNow'), eventActionResult: 'open' }"
        >
          {{ $t('message.common.applyNow') }}
        </MobialisButton>
      </div>
    </div>
  </mobialisCard>
</template>

<script>
export default {
  name: 'ApplyNow',
  data() {
    return {};
  },
  methods: {
    btnClick() {
      this.goToAVFinanceFlow();
    },
  },
};
</script>

<style lang="scss" scoped>
h2.heading {
  font-size: 20px;
  font-weight: bold;
  line-height: 25px;
  @media (max-width: $breakpoint-mobile) {
    font-size: 18px;
    line-height: 22.5px;
  }
}
p {
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  color: #4b5863;
}
</style>
